import { Injectable } from '@angular/core';

import { BasicService } from '../../services/basic.service';

@Injectable()
// @ts-ignore
export class SystemConfigurationService extends BasicService {
  exportOperationLogExcel(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/operationLog/exportExcel`,
      body,
      headers,
      options,
    });
  }

  systemDownloadFile(id, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/exportJob/${id}/downloadFile`,
      body: {
        id,
      },
      headers,
      options,
    });
  }

  getSystemInfo() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/systemInfo`,
    });
  }

  // TODO 水价归属接口开始
  getCategoriesTree(state?) {
    return this.get({
      url: `${this.apiUrl}/api/app/price/categoriesTree`,
      params: {
        ...(state === null ? {} : { state }),
      },
    });
  }

  createWaterCategory(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/category`,
      body: {
        categoryCode: value.code,
        categoryName: value.name,
        parentId: value.parentId,
        level: value.level,
        remark: value.remark,
      },
    });
  }

  getWaterCategoryDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/price/${id}/category`,
    });
  }

  updateWaterCategory(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${value.id}/updateCategory`,
      body: {
        parentId: value.parentId || 0,
        categoryCode: value.code,
        categoryName: value.name,
        remark: value.remark,
      },
    });
  }

  updateWaterCategoryStatus(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${id}/disableCategory`,
    });
  }

  waterCategoryCodeValidator(id, code) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${id}/existsCategoryCode`,
      body: {
        code,
      },
    });
  }

  waterCategoryNameValidator(id, name) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${id}/existsCategoryName`,
      body: {
        name,
      },
    });
  }

  sortWaterCategory(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${value.id}/sortCategory`,
      body: {
        parentId: value.parentId,
        level: value.level,
        sort: value.sort,
      },
    });
  }

  // TODO 水价归属接口结束

  // TODO 费用组成接口开始
  getCostCompositionList() {
    return this.get({
      url: `${this.apiUrl}/api/app/price/items`,
    });
  }

  updateCostCompositionIsComputed(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${id}/updateItemIsComputed`,
    });
  }

  updateCostCompositionState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${id}/updateItemState`,
    });
  }

  updateCostCompositionIsTax(id) {
    return this.put({
      url: `${this.apiUrl}/api/app/price/${id}/itemIsTax`,
    });
  }

  updateCostComposition(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/${value.id}/updateItem`,
      body: {
        itemName: value.itemName,
        penaltyCoefficient: value.penaltyCoefficient,
        isTax: value.isTax,
        isComputed: value.isComputed,
        state: value.state ? 0 : -1,
        remark: value.remark,
      },
    });
  }

  // TODO 费用组成接口结束

  // TODO 水价调整接口开始
  getLeafCategories() {
    return this.get({
      url: `${this.apiUrl}/api/app/price/categories`,
    });
  }

  saveWaterPriceAdjustment(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/adjustment`,
      body: {
        ...value,
      },
    });
  }

  createOrUpdateTempStore(value, storeType: number = 1) {
    return this.post({
      url: `${this.apiUrl}/api/app/tempStore/save`,
      body: {
        ...(value.id ? { id: value.id } : {}),
        storeType,
        jsonContent: JSON.stringify(value),
      },
    });
  }

  deleteTempStore(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/tempStore/${id}/delete`,
    });
  }

  getUserTempStore(storeType: number = 1) {
    return this.get({
      url: `${this.apiUrl}/api/app/tempStore`,
      params: {
        storeType,
      },
    });
  }

  getLastAdjustment() {
    return this.get({
      url: `${this.apiUrl}/api/app/price/lastAdjustment`,
    });
  }

  getWaterStationList(state?) {
    return this.get({
      url: `${this.apiUrl}/api/app/orgAnization`,
      params: {
        ...(state === null ? {} : { state }),
      },
    });
  }

  getWaterAdjustmentLogs(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/price/logs`,
      params: {
        ...pageAssistant,
      },
    });
  }

  getExistsOtherAdjusting() {
    return this.post({
      url: `${this.apiUrl}/api/app/price/existsOtherAdjusting`,
    });
  }

  getAdjustmentById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/price/${id}/adjustment`,
    });
  }

  undoAdjustmentById(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/price/removeAdjustment`,
      body: {
        priceListId: id,
      },
    });
  }

  // TODO 水价调整接口结束

  // TODO 词语
  getWordItems(key) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordItemsByGroupKey`,
      params: {
        groupKey: key,
      },
    });
  }

  // TODO 词语结束
  /**
   * 水表厂家模块接口
   */
  addMeterProducer(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterProducer`,
      body: {
        ...value,
        isActive: value.isActive ? value.isActive : 0,
        remark: value.remark,
      },
    });
  }

  getMeterProducerPageList(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterProducer/meterProducerPageList`,
      params: {
        ...pageAssistant,
      },
    });
  }

  getMeterProducerModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterProducer/${id}/model`,
    });
  }

  updateMeterProducerStart(id, state) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterProducer/${id}/updateStart`,
      params: {
        state,
      },
    });
  }

  updateMeterProducer(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterProducer/updata`,
      body: value,
    });
  }

  /**
   * 用户信息接口
   */
  getCustomUser() {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/users`,
    });
  }

  getUserOrgs() {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/userOrgs`,
    });
  }

  // 绑定微信
  bindWeChatAPI(code) {
    return this.post({
      url: `${this.apiUrl}/api/app/socialLoginBinding/bindWeChat`,
      params: {
        code,
      },
    });
  }

  /**
   * 水表型号
   */
  getMeterAll(state) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterProducer/meterAll`,
      params: {
        state,
      },
    });
  }

  getMeterModelList(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterModels/meterModelPageList`,
      params: {
        ...pageAssistant,
      },
    });
  }

  addMeterModels(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterModels`,
      body: {
        modelCode: value.modelCode,
        modelName: value.modelName,
        modelRange: value.modelRange,
        producerId: value.producerId,
        state: value.state ? value.state : 0,
        remark: value.remark,
      },
    });
  }

  getMeterModelsModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterModels/${id}/model`,
    });
  }

  updateMeterModels(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterModels/update`,
      body: {
        id: value.id,
        modelCode: value.modelCode,
        modelName: value.modelName,
        modelRange: value.modelRange,
        producerId: value.producerId,
        state: value.state,
        remark: value.remark,
      },
    });
  }

  updateMeterModelStart(id, state) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterModels/${id}/updateStart`,
      params: {
        state,
      },
    });
  }

  deleteModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterModels/${id}/delete`,
    });
  }

  /**
   * 水表口径
   */
  getMeterCaliberList(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterCaliber/meterCaliberPageList`,
      params: {
        ...pageAssistant,
      },
    });
  }

  addMeterCaliber(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterCaliber`,
      body: {
        caliberName: value.caliberName,
        caliberValue: value.caliberValue,
        caliberHigh: value.caliberHigh,
        caliberLow: value.caliberLow,
        state: value.state ? value.state : 0,
        remark: value.remark,
        activeTime: value.activeTime,
        billing: value.billing,
      },
    });
  }

  getMeterCaliber(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterCaliber/${id}/model`,
    });
  }

  updateMeterCaliber(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterCaliber/update`,
      body: {
        id: value.id,
        caliberName: value.caliberName,
        caliberValue: value.caliberValue,
        caliberHigh: value.caliberHigh,
        caliberLow: value.caliberLow,
        state: value.state,
        remark: value.remark,
        activeTime: value.activeTime,
        billing: value.billing,
      },
    });
  }

  updateMeterCaliberStart(id, state) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterCaliber/${id}/updateStart`,
      params: {
        state,
      },
    });
  }

  deleteMeterCaliber(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterCaliber/${id}/delete`,
    });
  }

  /**
   * 水表量程
   */
  getMeterRanges(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterRange/meterRanges`,
      params: {
        ...pageAssistant,
      },
    });
  }

  addMeterRange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterRange/meterRange`,
      body: {
        rangeCode: value.rangeCode,
        rangeName: value.rangeName,
        rangeValue: value.rangeValue,
        state: value.state ? value.state : 0,
        remark: value.remark,
      },
    });
  }

  updateMeterRange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterRange/updateMeterRange`,
      body: {
        meterRangeId: value.id,
        rangeCode: value.rangeCode,
        rangeName: value.rangeName,
        rangeValue: value.rangeValue,
        state: value.state,
        remark: value.remark,
      },
    });
  }

  getMeterRangeModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterRange/${id}/model`,
    });
  }

  disableMeterRange(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterRange/${id}/disableMeterRange`,
    });
  }

  // TODO 营业站点开始
  getOrgAnizationList(state?) {
    return this.get({
      url: `${this.apiUrl}/api/app/orgAnization`,
      params: {
        ...(state === null ? {} : { state }),
      },
    });
  }

  getOrgAnizationDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/orgAnization/${id}/model`,
    });
  }

  updateOrgAnizationState(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/orgAnization/${value.key}/updateStart`,
      params: {
        state: value.origin?.state === 0 ? -1 : 0,
      },
    });
  }

  createOrUpdateOrgAnization(value) {
    if (value.id) {
      return this.post({
        url: `${this.apiUrl}/api/app/orgAnization/update`,
        body: {
          ...value,
        },
      });
    } else {
      return this.post({
        url: `${this.apiUrl}/api/app/orgAnization`,
        body: {
          ...value,
        },
      });
    }
  }

  // TODO 营业站点结束

  // TODO 所属小区开始
  getAreasList(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/areasAll/${id}`,
    });
  }

  getAllActiveAreasList(state = 0) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/areasTree`,
      params: {
        state,
      },
    });
  }

  areasMoveApi(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/areas/areasMove`,
      body,
    });
  }
  deleteAreasApi(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/${id}/deleteAreas`,
    });
  }

  getActiveAreasList(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/activeAreasTrees/${id}`,
    });
  }

  getAreasParentList(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/areasParentAll/${id}`,
    });
  }

  getAreasChildrenList(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/areasChildren/${id}`,
    });
  }

  getAreasDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/areas/${id}/areasById`,
    });
  }

  createOrUpdateArea(value) {
    if (value.id) {
      return this.post({
        url: `${this.apiUrl}/api/app/areas/updateAreas`,
        body: {
          ...value,
        },
      });
    } else {
      return this.post({
        url: `${this.apiUrl}/api/app/areas/areas`,
        body: {
          ...value,
        },
      });
    }
  }

  updateAreasState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/areas/${id}/disableAreas`,
    });
  }

  // TODO 所属小区结束

  /**
   * 词语信息接口
   */
  getWordListOnPaged(appName?) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordGroup`,
      params: {
        appName,
      },
    });
  }

  getWordItemsByGroupKe(groupKey) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordItemsByGroupKey`,
      params: {
        groupKey,
      },
    });
  }

  getWordItemsByGroupKeys(groupKeys) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordItemsByGroupKeys`,
      params: {
        groupKeys,
      },
    });
  }

  getWordTreeByGroupKe(groupKey) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordsTreeList`,
      params: {
        groupKey,
      },
    });
  }

  getWordTreeValueByGroupKey(groupKey) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordsKeyValueTreeList`,
      params: {
        groupKey,
      },
    });
  }

  addOrUpdateWordItem(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/words/wordItemCreateOrUpdate`,
      body: {
        words: {
          id: value.id ? value.id : '',
          appName: value.appName ? value.appName : '',
          wordParendId: value.wordParendId ? value.wordParendId : 0,
          wordGroupkey: value.wordGroupkey,
          wordKey: value.wordKey,
          wordText: value.wordText,
          wordValue: value.wordValue ? value.wordValue : 0,
          wordRemark: value.wordRemark,
          wordState: value.wordState ? value.wordState : true,
          canEdit: value.canEdit ? value.canEdit : true,
          wordSortIndex: value.wordSortIndex ? value.wordSortIndex : 0,
        },
      },
    });
  }

  changeWordState(wordId, wordState) {
    return this.post({
      url: `${this.apiUrl}/api/app/words/updateWordState/${wordId}`,
      params: {
        wordState,
      },
    });
  }

  getWordsById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/${id}/byId`,
    });
  }

  /**
   * 微信配置接口
   */
  getweChatSet() {
    return this.get({
      url: `${this.apiUrl}/api/app/weChatSet/chatSet`,
    });
  }

  addOrUpdateWeChatSet(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/weChatSet/orUpdateWeChatSet`,
      body: {
        publicAcctountName: value.publicAcctountName,
        publicAcctountId: value.publicAcctountId,
        businessAcctountId: value.businessAcctountId,
        businessPaySecretkey: value.businessPaySecretkey,
        weChatAppSecret: value.weChatAppSecret,
        queryArrearageUrl: value.queryArrearageUrl,
        userBindingUrl: value.userBindingUrl,
        weChatPayUrl: value.weChatPayUrl,
        dateTimeStart: value.dateTimeStart,
        dateTimeEnd: value.dateTimeEnd,
        mobile: value.mobile,
      },
    });
  }

  // 租户名
  getUserTitle() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/userTitle`,
    });
  }

  /**
   * 参数配置接口
   */
  //
  getSettingsList() {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/settingGroup`,
    });
  }

  getSettingsItemById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/${id}/settingItemsGetById`,
    });
  }

  getSettingsByCodes(codes) {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/bySettingCodes`,
      params: {
        settingCodes: codes,
      },
    });
  }

  getSettingsByCode(code) {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/bySettingCode`,
      params: {
        settingCode: code,
      },
    });
  }

  getSettingsByGroupKey(code) {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/byGroupKey`,
      params: {
        settingGroup: code,
      },
    });
  }

  addOrUpdateSettingItem(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/settings/settingItemCreateOrUpdate`,
      body: {
        settings: {
          id: value.id ? value.id : '',
          settingCode: value.settingCode,
          settingName: value.settingName,
          settingRemark: value.settingRemark,
          settingValue: value.settingValue,
          settingDefault: value.settingDefault ? value.settingDefault : '',
          settingGroup: value.settingGroup,
          isRed: value.isRed,
          settingState: true,
          canEdit: true,
        },
      },
    });
  }

  // TODO 抄表状态开始
  getLargeMeterReadState() {
    return this.get({
      url: `${this.apiUrl}/api/app/meterReadState/classifyAll`,
    });
  }

  getSmallMeterReadState(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterReadState/detailStateAll/${id}`,
    });
  }

  createOrUpdateMeterReadState(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReadState/orEditMeterReadState`,
      body: {
        ...value,
      },
    });
  }

  updateMeterReadStateState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReadState/${id}/disableMeterReadStates`,
    });
  }

  queryAllDetailState() {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReadState/queryDetailStateAll`,
    });
  }

  // TODO 抄表状态结束
  /**
   * 用户信息接口
   */
  getProfile() {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/profile`,
    });
  }

  updateProfile(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/updateProfile`,
      body,
    });
  }

  changePassword(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/changePassword`,
      body: {
        currentPassword: value.oldPassword,
        newPassword: value.newPassword,
      },
    });
  }

  // TODO 银行信息开始
  getBankList(state?) {
    return this.get({
      url: `${this.apiUrl}/api/app/bank`,
      params: {
        ...(state ? { state } : {}),
      },
    });
  }

  getBranchBankList(id, state?) {
    return this.get({
      url: `${this.apiUrl}/api/app/bankBranch`,
      params: {
        parentId: id,
        ...(state ? { state } : {}),
      },
    });
  }

  updateBankState(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bank/${value.id}/updateStart`,
      params: {
        state: value.state,
      },
    });
  }

  updateBranchState(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bankBranch/${value.id}/updateStart`,
      params: {
        state: value.state,
      },
    });
  }

  createBank(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bank`,
      body: {
        ...value,
      },
    });
  }

  updateBank(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bank/update`,
      body: {
        ...value,
      },
    });
  }

  createBankBranch(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bankBranch`,
      body: {
        ...value,
      },
    });
  }

  updateBankBranch(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/bankBranch/update`,
      body: {
        ...value,
      },
    });
  }

  getBankBranchDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/bankBranch/${id}/model`,
    });
  }

  // TODO 银行信息结束

  /**
   * 发票税率接口
   */
  // 获取发票供应商
  invoiceSupplier() {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceInfo/invoiceSupplier`,
    });
  }
  getInvoiceTaxRate(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceTaxRate`,
      params: {
        sellerName: value,
      },
    });
  }

  // 获取发票费用组成
  priceItems() {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceInfo/priceItems`,
    });
  }

  // 获取开票配置参数
  invoiceSettings(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceInfo/invoiceSettings/${id}`,
    });
  }

  // 更新泰易发票
  taxEasySettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateTaxEasySettings`,
      body: value,
    });
  }

  // 更新上海电子发票
  shdzfpSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateShdzfpSettings`,
      body: value,
    });
  }

  // 更新用友发票
  yonYouSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateYonYouSettings`,
      body: value,
    });
  }

  // 更新百旺通发票
  bwtInvoiceSetting(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateBwjfSettings`,
      body: value,
    });
  }

  // 更新百旺通数电发票
  bwtsdInvoiceSetting(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateBwjfElectricSettings`,
      body: value,
    });
  }

  // 4大象慧云发票供应商
  elephantSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateElephantSettings`,
      body: value,
    });
  }

  // 111大象慧云数电发票供应商
  elephantElectricSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateElephantElectricSettings`,
      body: value,
    });
  }

  // 5诺诺发票供应商
  nuoNuoSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateNuoNuoSettings`,
      body: value,
    });
  }

  // 0自定义发票供应商
  customSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateCustomSettings`,
      body: value,
    });
  }

  // 101博思发票供应商
  bossSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateBossSettings`,
      body: value,
    });
  }

  // 103用友全电发票供应商
  YonYouFullElectricSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateYonYouFullElectricSettings`,
      body: value,
    });
  }

  // 104诺诺全电发票供应商
  updateNuoNuoFullElectricSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateNuoNuoFullElectricSettings`,
      body: value,
    });
  }

  // 105贵州航信发票供应商
  updateGZHXSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateGZHXSettings`,
      body: value,
    });
  }

  // 106上海容津发票供应商
  updateSHRJSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateSHRJSettings`,
      body: value,
    });
  }

  // 107福建数科发票供应商
  updateFJSKSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateFJSKSettings`,
      body: value,
    });
  }

  // 108方欣全电发票供应商
  updateForeseeSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateForeseeSettings`,
      body: value,
    });
  }

  // 112保定航信数电发票
  updateBDHXSettings(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceInfo/updateBDSettings`,
      body: value,
    });
  }

  getInvoiceTaxRateData() {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceTaxRate`,
    });
  }

  updateInvoiceTaxRate(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceTaxRate/orEditInvoiceTaxRate`,
      body: value,
    });
  }

  setIsAddedValue(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoiceTaxRate/${id}/setIsAddedValue`,
    });
  }

  getInvoiceTacRateById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceTaxRate/${id}/invoiceTaxRateById`,
    });
  }

  // TODO 优惠方案开始
  getPreferentialPlanList() {
    return this.get({
      url: `${this.apiUrl}/api/app/preferentialPlan`,
    });
  }

  getPreferentialPlanDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/preferentialPlan/${id}/model`,
    });
  }

  createPreferentialPlan(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/preferentialPlan`,
      body: {
        ...value,
      },
    });
  }

  updatePreferentialPlan(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/preferentialPlan/update`,
      body: {
        ...value,
      },
    });
  }

  updatePreferentialState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/preferentialPlan/${id}/updateState`,
    });
  }

  getAvailablePrice() {
    return this.get({
      url: `${this.apiUrl}/api/app/price/avaliablePriceInfoes`,
    });
  }

  getCostCompositionsById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/price/priceItemsOfPriceInfo/${id}`,
    });
  }

  getPreferentialListByPriceCode(priceCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/preferentialPlan/priceCodeList`,
      params: {
        priceCode,
      },
    });
  }

  // TODO 优惠方案结束

  /**
   * 水司账户接口
   */
  getWaterCompanyAccount() {
    return this.get({
      url: `${this.apiUrl}/api/app/waterCompanyAccount`,
    });
  }

  getWaterCompanyAccountById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/waterCompanyAccount/${id}/infoById`,
    });
  }

  getWaterCompanyOrg(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/waterCompanyAccount/${id}/orgAnizationTrees`,
    });
  }

  getInvoiceInfoSetting() {
    return this.get({
      url: `${this.apiUrl}/api/app/invoiceInfo/setting`,
    });
  }

  updateWaterCompanyAccount(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterCompanyAccount/orEditWaterCompanyAccount`,
      body: {
        id: value.id ? value.id : 0,
        sellerName: value.sellerName,
        creditCode: value.creditCode,
        address: value.address,
        mobile: value.mobile,
        openBanks: value.openBanks,
        openAccount: value.openAccount,
        specialOpenAccount: value.specialOpenAccount,
        checker: value.checker,
        payee: value.payee,
        drawer: value.drawer,
        inVoiceRemark: value.inVoiceRemark,
      },
    });
  }

  disableWaterCompanyAccount(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterCompanyAccount/${id}/disableWaterCompanyAccount`,
    });
  }

  AddWaterCompanyAccountOrg(id, orgIdArr) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterCompanyAccount/${id}/setAccountOrg`,
      body: orgIdArr,
    });
  }

  // TODO 计划用水方案开始
  getWaterOverPlanList() {
    return this.get({
      url: `${this.apiUrl}/api/app/waterOverPlan`,
    });
  }

  getWaterOverPlanDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/waterOverPlan/${id}/model`,
    });
  }

  createWaterOverPlan(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterOverPlan`,
      body: {
        ...value,
      },
    });
  }

  updateWaterOverPlan(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterOverPlan/update`,
      body: {
        ...value,
      },
    });
  }

  updateWaterOverPlanState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/waterOverPlan/${id}/updateState`,
    });
  }

  /**
   * 权限管理接口开始
   */
  getCustomPermission(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/customPermission/permissions`,
      params: {
        ...pageAssistant,
      },
    });
  }

  createPermission(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customPermission/permission`,
      body: {
        ...value,
      },
    });
  }

  updatePermission(id, value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customPermission/${id}/updatePermission`,
      body: {
        ...value,
      },
    });
  }

  getRoles(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/customPermission/${id}/roles`,
    });
  }

  getUsers(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/customPermission/${id}/users`,
    });
  }

  getOrgTree() {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/organizationTree`,
    });
  }

  getUsersByOrgId(roleName, orgId) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/roleUsersOfOrganizationByOrgId/${orgId}`,
      params: {
        roleName,
      },
    });
  }

  grandRolesPermission(value, id) {
    return this.post({
      url: `${this.apiUrl}/api/app/customPermission/${id}/grantRolePermissions`,
      body: {
        objects: [...value],
      },
    });
  }

  grandUsersPermission(value, id) {
    return this.post({
      url: `${this.apiUrl}/api/app/customPermission/${id}/grantUserPermissions`,
      body: {
        objects: [...value],
      },
    });
  }

  /**
   * 菜单管理接口开始
   */
  getAllMenuTree(key) {
    return this.get({
      url: `${this.apiUrl}/api/app/menu/tree`,
      params: {
        keywords: key,
      },
    });
  }

  getMenuPermission(key) {
    return this.get({
      url: `${this.apiUrl}/api/app/menu/permissions`,
      params: {
        keywords: key,
      },
    });
  }

  getMenuDetailById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/menu/${id}`,
    });
  }

  updateMenu(value, id) {
    return this.post({
      url: `${this.apiUrl}/api/app/menu/${id}/update`,
      body: {
        ...value,
      },
    });
  }

  createMenu(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/menu`,
      body: {
        ...value,
      },
    });
  }

  disableMenu(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/menu/${id}/disableMenu`,
    });
  }

  // TODO 角色分配开始
  getRolesList(pageAssistant) {
    // 获取角色列表
    return this.get({
      url: `${this.apiUrl}/api/app/customRole/roles`,
      params: {
        ...pageAssistant,
      },
    });
  }

  exportCustomRoles(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/customRole/export`,
      body,
      headers,
      options,
    });
  }

  getRolePermissionDetail(id) {
    // 获取角色分配的权限详情
    return this.get({
      url: `${this.apiUrl}/api/app/customRole/rolePermissionDetail/${id}`,
    });
  }

  getRoleUsers(id) {
    // 获取角色关联的用户
    return this.get({
      url: `${this.apiUrl}/api/app/customRole/${id}/roleUsers`,
    });
  }

  getRolePermissions(id) {
    // 获取角色权限
    return this.get({
      url: `${this.apiUrl}/api/app/customRole/rolePermissions/${id}`,
    });
  }

  createCustomRole(value) {
    // 创建角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole`,
      body: {
        ...value,
      },
    });
  }

  updateCustomRole(id, value) {
    // 更新角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/${id}/update`,
      body: {
        ...value,
      },
    });
  }

  updateSingleRoleState(id) {
    // 禁用启用角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/${id}/toggleState`,
    });
  }

  disableBatchRole(roles) {
    // 批量禁用角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/batchDisable`,
      body: {
        roles,
      },
    });
  }

  enableBatchRole(roles) {
    // 批量启用角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/batchEnable`,
      body: {
        roles,
      },
    });
  }

  updateRoleUsers(id, value) {
    // 更新角色关联的用户
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/${id}/updateUsers`,
      body: {
        users: value,
      },
    });
  }

  updateRolePermissions(id, value) {
    // 更新角色权限
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/updateRolePermissions`,
      params: {
        providerKey: id,
      },
      body: {
        permissions: value,
      },
    });
  }

  copyRole(id) {
    // 拷贝角色
    return this.post({
      url: `${this.apiUrl}/api/app/customRole/${id}/copyRole`,
    });
  }

  // TODO 角色分配结束

  /**
   * 用户管理接口开始
   */
  getCustomUserList(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/users`,
      params: {
        ...pageAssistant,
      },
    });
  }

  exportCustomUsers(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/customUser/export`,
      body,
      headers,
      options,
    });
  }

  createCustomUser(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/user`,
      body: {
        ...value,
      },
    });
  }

  updateCustomUser(value, id) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/${id}/updateUser`,
      body: {
        ...value,
      },
    });
  }

  getUserRole(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/${id}/userRoles`,
    });
  }

  updateUserRole(value, id) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/${id}/updateRoles`,
      body: {
        roleNames: [...value],
      },
    });
  }

  getUserPermission(userId) {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/userPermissions/${userId}`,
    });
  }

  updateUserPermissions(value, userId) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/updateUserPermissions/${userId}`,
      body: {
        permissions: [...value],
      },
    });
  }

  resetUserPassword(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/resetUserPassword`,
      body: {
        ...value,
      },
    });
  }

  batchDisableUser(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/batchDisable`,
      body: {
        users: [...value],
      },
    });
  }

  batchEnableUser(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/batchEnable`,
      body: {
        users: [...value],
      },
    });
  }

  toggleUserState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/customUser/${id}/toggleState`,
    });
  }

  getUserPerDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/customUser/${id}/userPermissionDetail`,
    });
  }

  unbindWeChat(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/socialLoginBinding/unbindWeChat`,
      body: {
        userId: id,
      },
    });
  }

  // 获取当前登录用户所属站点
  getSysOrgTree() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/organizationsTree`,
    });
  }

  // 通用设置页面-----上传、下载文件接口
  //
  // 未登录时获取文件信息
  getPageSettingByTenantId(tenantId) {
    return this.post({
      url: `${this.apiUrl}/api/app/system/getLoginPageSetting`,
      body: {
        tenantId,
      },
    });
  }

  getPageSetting() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/pageSetting`,
    });
  }

  savePageSetting(id, value) {
    return this.post({
      url: `${this.apiUrl}/api/app/system/${id}/savePageSetting`,
      body: value,
    });
  }

  fileUpload(file) {
    return this.post({
      url: `${this.apiUrl}/api/fileManagement/file`,
      body: {
        FileContainerName: 'default',
        FileType: 2,
        File: file,
        GenerateUniqueFileName: true,
      },
    });
  }

  getDownloadInfo(id) {
    return this.get({
      url: `${this.apiUrl}/api/fileManagement/file/${id}/downloadInfo`,
      params: {
        id,
      },
    });
  }

  downloadFile(fileId, fileToken) {
    return this.get({
      url: `${this.apiUrl}/api/fileManagement/file/${fileId}/download`,
      params: {
        token: fileToken,
      },
    });
  }

  // 导入数据模块接口开始
  // 数据导入----册本信息
  getMeterBooks(searchParams) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/inquireMeterBooks`,
      body: {
        ...searchParams,
      },
    });
  }

  saveUploadBooks(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/uploadMeterBooks`,
      body: value,
    });
  }

  submitBooks() {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/buildMeterBooks`,
    });
  }

  // 数据导入----客户信息
  getCustInfoData(searchParams) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/inquireCustomers`,
      body: {
        ...searchParams,
      },
    });
  }

  saveUploadCustInfo(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/uploadCustomers`,
      body: value,
    });
  }

  submitCustInfo() {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/buildCustomers`,
    });
  }

  queryCustImportData(pageAssistant) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/inquireCustomerTemporaryData`,
      body: pageAssistant,
    });
  }

  // 数据导入----账务信息
  getAccountInfoData(searchParams) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/inquireCharges`,
      body: {
        ...searchParams,
      },
    });
  }

  saveUploadAccountInfo(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/uploadCharges`,
      body: value,
    });
  }

  submitAccountInfo() {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/buildCharges`,
    });
  }

  queryAccountData(pageAssistant) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/inquirChargeTemporaryData`,
      body: pageAssistant,
    });
  }

  // 数据导入确认数据接口  ------  1：册本 2：客户 3：营业帐
  batchConfirmData(ids, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/batchConfirmImData`,
      body: ids,
      params: {
        dataType: type,
      },
    });
  }

  // 数据导入删除接口  ------  1：册本 2：客户 3：营业帐
  batchDeleteData(ids, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/batchDeleteImData`,
      body: ids,
      params: {
        dataType: type,
      },
    });
  }

  // 数据导入清空接口  ------  1：册本 2：客户 3：营业帐
  clearImportData(type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/deleteAllImportData`,
      params: {
        dataType: type,
      },
    });
  }

  // 修改临时数据为有效数据 ---- 2: 客户数据 3：账务数据
  changeValueState(code, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/updateValidState`,
      params: {
        uniqueCode: code,
        dataType: type,
      },
    });
  }

  // 删除临时数据 ---- 2: 客户数据 3：账务数据
  deleteTemporaryState(code, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/deleteTemporaryData`,
      params: {
        uniqueCode: code,
        dataType: type,
      },
    });
  }

  // 数据保存进度查询 ---- 2: 客户数据 3：账务数据
  getSaveProgress(code, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/saveProgress`,
      params: {
        uniqueCode: code,
        dataType: type,
      },
    });
  }

  // 有效数据提交进度查询 ---- 2: 客户数据 3：账务数据
  getBuildProgress(time, type) {
    return this.post({
      url: `${this.apiUrl}/api/app/customerImport/buildProgress`,
      params: {
        dateTime: time,
        dataType: type,
      },
    });
  }

  // TODO 文件上传开始
  getTempSecretKey(obj) {
    return this.get({
      url: `${this.uploadUrl}/api/app/files/tempSecretKey`,
      params: {
        FileSource: obj.fileSource,
        Bucket: obj.bucket,
        Prefix: obj.prefix,
      },
    });
  }

  localFileDownloadInfo(id) {
    return this.get({
      url: `${this.uploadUrl}/api/fileManagement/file/${id}/downloadInfo`,
    });
  }

  localFileUpload(value) {
    return this.post({
      url: `${this.uploadUrl}/api/fileManagement/file`,
      body: {
        ...value,
      },
    });
  }

  // localFileDownload(id, token) {
  //   return this.get({
  //     url: `${this.uploadUrl}/api/ fileManagement/file/${id}/download`,
  //     params: {
  //       token
  //     }
  //   });
  // }
  downloadLoginIconToken(path) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/downloadLoginIconToken`,
      params: {
        filePath: path,
      },
    });
  }

  downloadLoginIcon(path, TenantId) {
    return this.get({
      url: `${this.uploadUrl}/api/app/files/downloadLoginIcon`,
      params: {
        FilePath: path,
        TenantId,
      },
    });
  }
  // 获取业务类型文件信息 systemSource：1: 营收，2: 热线，3: PDA，4: 小程序
  getFileList(value) {
    return this.post({
      url: `${this.uploadUrl}/api/app/files/getList`,
      body: value,
    });
  }
  // 动态列模块接口开始
  queryTableTemplate() {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/queryTableTemplates`,
      body: {
        skipCount: 0,
        maxResultCount: 999,
      },
    });
  }

  createTableTemplate(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/tableMade`,
      body: value,
    });
  }

  modifyTableTemplate(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/updateTableMade`,
      body: value,
    });
  }

  queryTableFields(templateId) {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/queryTableFields/${templateId}`,
      body: {
        skipCount: 0,
        maxResultCount: 999,
      },
    });
  }

  createTableField(templateId, value) {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/tableField/${templateId}`,
      body: value,
    });
  }

  modifyTableField(templateId, value) {
    return this.put({
      url: `${this.apiUrl}/api/app/visualTable/tableField`,
      body: value,
    });
  }

  // 列表字段新增、修改
  updateTableField(TaleMadeId, fields) {
    return this.post({
      url: `${this.apiUrl}/api/app/visualTable/updateTableMadeField`,
      body: {
        id: TaleMadeId,
        fields,
      },
    });
  }

  // 审计日志
  getOperationLog(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/operationLog`,
      params: {
        ...pageAssistant,
      },
    });
  }

  getLogModules() {
    return this.get({
      url: `${this.apiUrl}/api/app/operationLog/logModules`,
    });
  }
  getLogTypesByModules(modules) {
    return this.post({
      url: `${this.apiUrl}/api/app/operationLog/getLogTypesByModule`,
      body: {
        modules,
      },
    });
  }

  // 流程相关接口开始
  getWorkFlowStepByTaskId(taskId) {
    return this.get({
      url: `${this.approvalUrl}/api/app/sH3HWorkflow/stepsByTaskId/${taskId}`,
    });
  }
  // 流程相关接口结束

  //  流程待办事项
  getTodoData() {
    return this.get({
      url: `${this.apiUrl}/api/app/home/todo`,
    });
  }
  // 三高退出登录
  logoutFor3H() {
    return this.post({
      url: `${this.apiUrl}/api/app/system/logout`,
    });
  }
  getBanks() {
    return this.get({
      url: `${this.apiUrl}/api/app/bank/organizationBankAll`,
      params: {
        name: '',
        state: null,
      },
    });
  }
  // TODO 流程相关接口结束

  loginByCode(data) {
    return this.post({
      url: `${this.authUrl}/api/user/oauth`,
      body: data,
    });
  }

  loginByToken(data) {
    if (data.systemSource) {
      // 云端部署项目单点登录
      return this.post({
        url: `${this.authUrl}/api/user/login/thirdpartytoken`,
        body: data,
      });
    } else {
      // 本地化部署项目单点登录
      return this.post({
        url: `${this.authUrl}/api/user/login/token`,
        body: data,
      });
    }
  }

  // 获取当前站点及其所属分公司所有人员
  getUsersOfOrganization(orgId) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/usersOfOrganization/${orgId}`,
    });
  }
  // pda抄表参数
  getSettingGroup() {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/pdaSettingGroup`,
    });
  }
  getPdaByGroupKey(code) {
    return this.get({
      url: `${this.apiUrl}/api/app/settings/pdaByGroupKey`,
      params: {
        groupName: code,
      },
    });
  }
  postPadSettingItemCreateOrUpdate(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/settings/pdaSettingItemCreateOrUpdate`,
      body: value,
    });
  }
  getTopFile() {
    return this.get({
      url: `${this.apiUrl}/api/app/exportJob/topFiles`,
    });
  }
  upDataTodoList(taskId) {
    return this.post({
      url: `${this.apiUrl}/api/app/home/updateWorkState/${taskId}`,
    });
  }
  upDataWorkflowState(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/exportJob/${id}/isRead`,
    });
  }

  pushMessageToMobileRead(userId, params) {
    return this.post({
      url: `${this.apiUrl}/api/app/phonePushMessage/push/${userId}`,
      params,
    });
  }

  commonPrint(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/print/print`,
      body: value,
    });
  }

  checkLodopType(code) {
    return this.post({
      url: `${this.apiUrl}/api/app/lodop/lodop`,
      params: {
        code,
      },
    });
  }
  // 户号规则
  getSequenceList(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/sequence/sequenceList`,
      params,
    });
  }
  postAddSequence(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/sequence/sequence`,
      body: value,
    });
  }
  getSequenceModel(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/sequence/${params.id}/model`,
    });
  }
  putEditSequence(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/sequence/updateSequence`,
      body: value,
    });
  }
  delSequence(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/sequence/${id}/deleteSequence`,
    });
  }
  getDisabledOrgList() {
    return this.get({
      url: `${this.apiUrl}/api/app/sequence/orgBindListAync`,
    });
  }

  // 获取所有定时任务
  getOpenJob(params) {
    return this.get({
      url: `${this.openWorkUrl}/api/app/openJob`,
      params,
    });
  }

  createOpenJob(body) {
    return this.post({
      url: `${this.openWorkUrl}/api/app/openJob`,
      body,
    });
  }

  updateOpenJob(body) {
    return this.post({
      url: `${this.openWorkUrl}/api/app/openJob/${body.id}/update`,
      body,
    });
  }

  deleteOpenJob(id) {
    return this.post({
      url: `${this.openWorkUrl}/api/app/openJob/${id}/delete`,
    });
  }

  changeOpenJobStatus(body) {
    return this.post({
      url: `${this.openWorkUrl}/api/app/openJob/changeJobStatus`,
      body,
    });
  }

  startOpenJobStatus(jobId) {
    return this.post({
      url: `${this.openWorkUrl}/api/app/openJob/executeNow/${jobId}`,
    });
  }

  getLocalOpenJobList() {
    return this.get({
      url: `${this.openWorkUrl}/api/app/openJob/localHandlers`,
    });
  }

  getOpenJobLogs(params) {
    return this.get({
      url: `${this.openWorkUrl}/api/app/openJob/jobLogs`,
      params,
    });
  }
  getRoleUsersByOrgCode(value, code) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/roleUsersOfOrganization`,
      params: {
        roleName: value,
        orgCode: code,
      },
    });
  }

  // 获取当前登录人所属站点下的收费员及银行列表
  getCashierAndBankList() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/orgUsers`,
    });
  }

  // 审计日志列表
  getAuditLogging(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/auditLogging`,
      params,
    });
  }
  // 清除租户Redis缓存
  clearCache() {
    return this.post({
      url: `${this.apiUrl}/api/app/system/clearCache`,
    });
  }

  //获取系统列表
  getSystemsList() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/systems`,
    });
  }

  // 通讯协议开始
  getCommunicationProtocolList(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterCommunicationProtocol/meterCommunicationProtocols`,
      params,
    });
  }

  createOrUpdateCommunicationProtocol(body) {
    if (body.id === null) {
      return this.createCommunicationProtocol(body);
    } else {
      return this.updateCommunicationProtocol(body);
    }
  }

  createCommunicationProtocol(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterCommunicationProtocol`,
      body,
    });
  }

  updateCommunicationProtocol(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterCommunicationProtocol/update`,
      body,
    });
  }
  // 通讯协议结束

  // 污水排放项目开始
  getSewageItemList(body?) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentItem/getSewageEffluentItem`,
      body,
    });
  }

  createOrUpdateSewageItem(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentItem/orUpdateSewageEffluentItem`,
      body,
    });
  }

  deleteSewageItem(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentItem/${id}/deleteSewageEffluentItem`,
    });
  }
  // 污水排放项目结束

  // 污水行业分类开始

  getSewageIndustryList(body?) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentIndustry/industry`,
      params: body,
    });
  }

  getSewageIndustryToCascader() {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentIndustry/industryToCascader`,
    });
  }

  createOrUpdateSewageIndustry(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentIndustry/orUpdateIndustry`,
      body,
    });
  }

  deleteSewageIndustry(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentIndustry/${id}/deleteIndustry`,
    });
  }

  // 污水行业分类结束

  // 污水超标水量系数开始

  getSewageOverWaterNumList() {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageOverWaterNum/sewageOverWaterNum`,
    });
  }

  createOrUpdateSewageOverWaterNum(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageOverWaterNum/orUpdateSewageOverWaterNum`,
      body,
    });
  }

  deleteSewageOverWaterNum(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageOverWaterNum/${id}/deleteSewageOverWaterNum`,
    });
  }

  // 污水超标水量系数结束

  // 污水超标排放价格开始

  getSewageOverPriceList() {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageOverPrice/sewageOverPrice`,
    });
  }

  createOrUpdateSewageOverPrice(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageOverPrice/orUpdateSewageOverPrice`,
      body,
    });
  }

  deleteSewageOverPrice(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageOverPrice/${id}/deleteSewageOverPrice`,
    });
  }

  // 污水超标排放价格结束

  // 污水排放标准开始

  getSewageEffluentStandardList(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/getSewageEffluentStandard`,
      body,
    });
  }

  createOrUpdateSewageEffluentStandard(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/orUpdateSewageEffluentStandard`,
      body,
    });
  }

  deleteSewageEffluentStandard(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/${id}/sewageEffluentStandard`,
    });
  }

  createOrUpdateStandardDetail(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/orUpdateStandardDetail`,
      body,
    });
  }

  deleteStandardDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/${id}/deleteStandardDetail`,
    });
  }

  getSewageEffluentStandardByCustId(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/${id}/sewageEffluentStandardByCustId`,
    });
  }

  getCustByCode(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentStandard/custByCode`,
      params,
    });
  }

  // 污水排放标准结束

  // 企业污水排放核定开始

  getSewageEffluentCheckList(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentCheck/getSewageEffluentCheck`,
      body,
    });
  }

  createOrUpdateSewageEffluentCheck(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentCheck/orUpdateSewageEffluentCheck`,
      body,
    });
  }

  deleteSewageEffluentCheck(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/sewageEffluentCheck/${id}/deleteSewageEffluentCheck`,
    });
  }

  exportSewageEffluentChecks(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentCheck/exportSewageEffluentChecks`,
      body,
    });
  }

  updateIndustryByCustId(custId, industryId) {
    return this.post({
      url: `${this.apiUrl}/api/app/sewageEffluentIndustry/updateIndustryByCustId`,
      params: {
        custId,
        industryId,
      },
    });
  }

  // 企业污水排放核定结束

  // 用水套餐方案接口开始
  getPackageScheme() {
    return this.get({
      url: `${this.apiUrl}/api/app/packageScheme`,
    });
  }

  postPackageScheme(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/packageScheme`,
      body: value,
    });
  }

  getPackageSchemeByPrice(priceCodes) {
    return this.get({
      url: `${this.apiUrl}/api/app/packageScheme/byPrice?${priceCodes}`,
    });
  }

  getPackageSchemeById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/packageScheme/${id}`,
    });
  }

  updatePackageSchemeById(id, body) {
    return this.post({
      url: `${this.apiUrl}/api/app/packageScheme/${id}/update`,
      body,
    });
  }

  updatePackageState(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/packageScheme/toggleState`,
      body,
    });
  }

  exprotPackage(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/package/export`,
      body,
      headers,
      options,
    });
  }
  // 用水套餐方案接口结束

  // 公告管理接口开始

  /**
   * 新增公告
   * @param body 公告内容
   */
  createAnnouncement(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/annManagement`,
      body,
    });
  }

  /**
   * 获取弹窗公告列表
   */
  getPopupAnnouncements(SystemCode = 'BizChargeSystem') {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/popupAnnList`,
      params: {
        SystemCode,
      },
    });
  }

  /**
   * 查询首页公告
   */
  getHomeAnnouncements(SystemCode = 'BizChargeSystem') {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/homeAnnList`,
      params: {
        SystemCode,
      },
    });
  }

  /**
   * 查询公告列表（分页）
   * @param params 查询参数，包含分页信息
   */
  getAnnouncementsPageList(params: any) {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/pageList`,
      params,
    });
  }

  /**
   * 删除公告
   * @param id 公告ID
   */
  deleteAnnouncement(id: string | number) {
    return this.post({
      url: `${this.apiUrl}/api/app/annManagement/${id}/delete`,
    });
  }

  /**
   * 撤销发布公告
   * @param id 公告ID
   */
  repealAnnouncement(id: string | number) {
    return this.post({
      url: `${this.apiUrl}/api/app/annManagement/${id}/annRepeal`,
    });
  }

  /**
   * 判断是否是平台
   */
  isPlatform() {
    return this.post({
      url: `${this.apiUrl}/api/app/annManagement/isPlatform`,
    });
  }

  /**
   * 修改公告
   * @param body 公告更新内容
   */
  updateAnnouncement(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/annManagement/update`,
      body,
    });
  }

  /**
   * 查询公告详情
   * @param id 公告ID
   */
  getAnnouncementDetail(id: string | number, params?: any) {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/${id}`,
      params,
    });
  }

  /**
   * 查询公告租户列表
   */
  getAnnouncementTenants() {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/annTenantList`,
    });
  }

  /**
   * 获取系统列表 (用于公告)
   */
  getAnnouncementSystems() {
    return this.get({
      url: `${this.apiUrl}/api/app/annManagement/systemList`,
    });
  }

  // 公告管理接口结束

  // Holiday
  createHoliday(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/holiday/holiday`,
      body,
    });
  }

  updateHoliday(body) {
    return this.put({
      url: `${this.apiUrl}/api/app/holiday/holiday`,
      body,
    });
  }

  getHoliday(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/holiday/holiday`,
      params,
    });
  }

  calculateCompletionDate(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/holiday/calculateCompletionDate`,
      body,
    });
  }

  /**
   * 查询水司站点数据
   * @param templateId 模板ID
   */
  getSignatureTemplateOrganizationTrees(templateId: string | number) {
    return this.get({
      url: `${this.apiUrl}/api/app/signaturesTemplateAppServie/orgAnizationTrees/${templateId}`,
    });
  }

  /**
   * 保存模板站点关系
   * @param templateId 模板ID
   * @param body 站点关系数据 { delOpt: number[], addOpt: number[] }
   */
  saveTemplateOrg(
    templateId: string | number,
    body: { delOpt?: number[]; addOpt?: number[] } = {},
  ) {
    return this.post({
      url: `${this.apiUrl}/api/app/signaturesTemplateAppServie/saveTemplateOrg/${templateId}`,
      body,
    });
  }
}
